import { toaster } from 'components/design-system/Toaster';
import { clientApiPatch } from 'lib/api_helper';
import { Listing } from 'types';

type UpdateReserveBody = {
  listingId: number;
  auctionInfo: Pick<Listing['auctionInfo'], 'reserveCents'>;
};

type UpdateReserveArgs = {
  setIsLoading: (val: boolean) => void;
  listing: Listing;
  newReserveValue: number | null;
  refreshListing?: (listing: Listing) => void;
  closeModal: () => void;
};

export const updateReserve = async ({
  setIsLoading,
  listing,
  newReserveValue,
  refreshListing,
  closeModal
}: UpdateReserveArgs) => {
  setIsLoading(true);
  try {
    const updatedListing = await clientApiPatch<Listing, UpdateReserveBody>(`/api/listings/seller`, {
      auctionInfo: {
        reserveCents: newReserveValue
      },
      listingId: listing.id
    });

    refreshListing?.({ ...listing, auctionInfo: updatedListing.auctionInfo });
    toaster.success(`Reserve successfully ${newReserveValue ? 'updated' : 'removed'}`);
    closeModal();
  } catch (error) {
    toaster.error('Updating reserve failed. Please try again');
    console.log(error);
  } finally {
    setIsLoading(false);
  }
};
